module.exports = __webpack_public_path__ + "static/media/architecture.40688aaf.png";


//////////////////
// WEBPACK FOOTER
// ./images/DashMobile/architecture.png
// module id = 447
// module chunks = 0